import { useTranslation } from "react-i18next";
import { Field } from "rc-field-form";
import Rule from "./Rule";

function GuaranteeRules({ disabled }) {
	const { t } = useTranslation();

	return (
		<div className="border-bottom mb-5">
			<div className="mb-2">
				<h3 className="text-sm">{t("guarantee-rules")}</h3>
			</div>

			<div className="mb-3">
				<Field shouldUpdate>
					{({ }, { }, { getFieldValue }) => {
						const rules = getFieldValue("guarantee");
						return Object.keys(rules || {}).map((type) => (
							<Rule key={type} type={type} disabled={disabled} />
						));
					}}
				</Field>
			</div>
		</div>
	);
}

export default GuaranteeRules;
